import { IconButton, InputAdornment, TextField, type SxProps, type Theme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
  size?: "small" | "medium";
  fullWidth?: boolean;
  variant?: "standard" | "outlined" | "filled";
  sx?: SxProps<Theme>;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
  label,
  size = "medium",
  fullWidth = false,
  variant = "outlined",
  sx,
}) => {
  return (
    <TextField
      label={label}
      placeholder={placeholder}
      value={value}
      size={size}
      fullWidth={fullWidth}
      variant={variant}
      onChange={(e) => onChange(e.target.value)}
      sx={sx}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" color="action" />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => onChange("")}
              edge="end"
              sx={{ "&:focus": { outline: "none", boxShadow: "none" } }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

export default SearchInput;
